var protectionHandleName = 'melting-protection-priority';
var defaultProtectionVariantId = 48122734313804;
var protectionVariations = {
  1: 48122734313804,
  2: 48480551764300,
  3: 48480551862604,
  4: 48480553468236,
  5: 48480553697612,
  6: 48480553763148,
};
var protectionPrice = window.dynamicProtectionPrice || 499;
var protectionInCartKey = 'protectionInCart';
var chocolateVariantIds = [47008450085196, 49213241459020, 51871432245580, 51871425495372, 51871436210508];
var selectedProtectionVariation = null;
var variations = Object.values(protectionVariations);
var protectionItem = null;

async function deleteProtectionItems(cartData) {
  const protectionItem = cartData.items.find(item => variations.includes(item.variant_id));

  if (!protectionItem) {
    return cartData;
  }

  const changeUrl = routes.cart_change_url;
  const body = JSON.stringify({ id: protectionItem.key, quantity: 0, sections: ['cart-icon-bubble', 'cart-drawer'] });
  const res = await fetch(changeUrl, { ...fetchConfig(), body }).then(res => res.json());
  const keys = Object.keys(res.sections);
  if (keys.length) {
    const sections = res.sections;
    for (const key of keys) {
      if (key === 'cart-drawer') {
        const newHeading = new DOMParser().parseFromString(sections[key], 'text/html').querySelector('.drawer__heading').innerHTML;
        const currHeading = document.querySelector('.drawer__heading');
        if (newHeading && currHeading) {
          currHeading.innerHTML = newHeading;
        }
        const newContent = new DOMParser().parseFromString(sections[key], 'text/html').querySelector('.drawer__contents').innerHTML;
        const currContent = document.querySelector('.drawer__contents');
        if (newContent && currContent) {
          currContent.innerHTML = newContent;
        }
        continue;
      }
      const item = document.getElementById(key);
      if (item) {
        item.innerHTML = res.sections[key];
      }
    }
  }

  const row = document.querySelector(`.cart__row[data-key="${protectionItem.key}"]`);
  if (row) {
    row.style.display = 'none';
  }
}

async function cleanUpCart(forceDelete) {
  if (localStorage.getItem(protectionInCartKey) === 'true' || forceDelete) {
    const cartData = await fetch(`/cart.js?r=${Date.now()}`).then(response => response.json());
    localStorage.setItem(protectionInCartKey, false);
    await deleteProtectionItems(cartData);
  }

  const data = await fetch(`/cart.js?r=${Date.now()}`).then(response => response.json());

  const protectionItem = data.items.find(item => variations.includes(item.variant_id));

  if (protectionItem) {
    return cleanUpCart(true);
  }

  return data;
}

async function onProtectionToggle(evt) {
  evt.stopPropagation();
  const isChecked = evt.target.checked;
  localStorage.setItem('protection', isChecked);
  const data = await cleanUpCart();
  updateSubtotals(data);
}

async function updateSubtotals(data) {
  let cartData = data;
  if (!cartData) {
    cartData = await fetch(`/cart.js?r=${Date.now()}`).then(response => response.json());
  }
  let subtotal = cartData.items_subtotal_price;
  const isChecked = localStorage.getItem('protection') === 'true';

  if (isChecked) {
      subtotal += protectionPrice;
  }

  document.getElementById("cart-subtotal").textContent = `${currencySymbol}${(subtotal / 100).toFixed(2)}`;
  // document.getElementById("cart-subtotal").textContent = `${userCurrency}${(subtotal / 100).toFixed(2)}`;
}

function getProtectionItemVariation(items) {
  const chocolates = items.filter((it) => chocolateVariantIds.includes(it.variant_id));

  if (!chocolates.length) {
    return;
  }

  const totalChocolateQuantity = chocolates.reduce((acc, it) => acc + it.quantity, 0);

  const selectedProtectionVariationId = protectionVariations[totalChocolateQuantity] ?? defaultProtectionVariantId;
  const protectionVariation = protectionItem.variants.find(({ id }) => id === selectedProtectionVariationId);

  return protectionVariation;
}

async function getProtectionItem() {
  protectionItem = await fetch(`/products/${protectionHandleName}.js`).then(response => response.json());
}

// Reconciles the automatic free card game (see free-gift.js). Degrades to a
// no-op if that asset is missing, so cart handling is never blocked by it.
function syncFreeGift() {
  if (window.SixsenseFreeGift) return window.SixsenseFreeGift.sync();
  return Promise.resolve();
}

class CartDrawer extends HTMLElement {

  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    // Sequenced after the protection cleanup so the two never mutate the cart
    // at the same time. Covers carts that already qualified before this load.
    cleanUpCart().then(() => syncFreeGift());
    getProtectionItem();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  async open(triggeredBy) {
    const updatedData = await cleanUpCart();
    const protectionVariation = getProtectionItemVariation(updatedData.items);
    selectedProtectionVariation = protectionVariation;
    if (protectionVariation && protectionVariation.available) {
      const protectionBlock = document.getElementById('cartUpgrade');
      if (protectionBlock) {
        protectionBlock.style.display = '';
      }
    } else {
      localStorage.removeItem('protection');
    }
    const toggle = document.getElementById('cartBodyUpgradeInput');
    if (toggle) {
      toggle.addEventListener('change', onProtectionToggle.bind(this));
      let isEnabled = localStorage.getItem('protection');

      if (protectionVariation && protectionVariation.available && isEnabled === null) {
        localStorage.setItem('protection', true);
        isEnabled = true;
      } else {
        isEnabled = isEnabled === 'true';
      }
      toggle.checked = isEnabled;
      updateSubtotals(updatedData);
    }
    
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');

    const checkoutButton = document.querySelector("#CartDrawer-Checkout");

    if (checkoutButton.getAttribute('listener') !== 'true') {
      checkoutButton.addEventListener("click", (e) => this.handleCheckoutClick.bind(this)(e, protectionVariation));
    }

    // Not awaited: the drawer opens immediately and the gift row renders itself
    // in once the cart has settled.
    syncFreeGift();
  }

  async handleCheckoutClick(event) {
    event.preventDefault();
    event.target.setAttribute('listener', 'true');

    const price = document.getElementById("cart-subtotal").textContent;

    dataLayer.push({ 'ecommerce': null });
    dataLayer.push({
      'event': 'cart-checkout-button',
      'ecommerce': {
          'currency': currencySymbol,
          'value': price
        }
    });
    if (selectedProtectionVariation && selectedProtectionVariation.available && localStorage.getItem('protection') === 'true' && localStorage.getItem(protectionInCartKey) !== 'true') {
      localStorage.setItem(protectionInCartKey, true)
      await this.addProduct({
        id: selectedProtectionVariation.id,
        quantity: 1
      });
    }

    window.location.href = "/checkout";
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.classList.remove('is-empty');
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
        childSectionSelectors: [
          '.drawer__heading',
          '.cart__free-shipping',
          '.drawer__contents',
          '.cart-drawer__footer-info'
        ]
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  async addProduct(product) {
    try {
      const response = await fetch(`/cart/add.js?r=${Date.now()}`, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify(product)
      });
      if (!response.ok) {
          throw new Error('Error adding product to cart');
      }
      const parsedData = await response.json();
      const variations = Object.values(protectionVariations);
      if (variations.includes(parsedData.id)) {
        const row = document.querySelector(`.cart__row[data-key="${parsedData.key}"]`);
        if (row) {
          row.style.display = 'none';
        }
      }
    } catch (error) {
        console.error('Error occured', error);
    }
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  constructor() {
    super();
    this.cartDrawerUpsells = this.querySelector('.cart-drawer-recommendations');
  }

  async updateSubtotals(isEnabled) {
    const cartData = await fetch(`/cart.js?r=${Date.now()}`).then(response => response.json());
    let subtotal = cartData.items_subtotal_price;

    if (isEnabled) {
        subtotal += protectionPrice;
    }

    document.getElementById("cart-subtotal").textContent = `${currencySymbol}${(subtotal / 100).toFixed(2)}`;
    // document.getElementById("cart-subtotal").textContent = `${userCurrency}${(subtotal / 100).toFixed(2)}`;
  }

  async updateQuantity(line, quantity, name, clear) {
    let hasUpdateFailed = false;
    try {
      await super.updateQuantity(line, quantity, name, clear);
    } catch {
      hasUpdateFailed = true;
    }
    // Before the protection block below, so it counts chocolate against a cart
    // whose gift line is already correct and has the last word on the subtotal.
    await syncFreeGift();
    const cartData = await cleanUpCart();
    const chocolates = cartData.items.filter((it) => chocolateVariantIds.includes(it.variant_id));
    if (!hasUpdateFailed && chocolates.length) {
      const totalChocolateQuantity = chocolates.reduce((acc, it) => acc + it.quantity, 0);
      const selectedProtectionVariationId = protectionVariations[totalChocolateQuantity] ?? defaultProtectionVariantId;
      selectedProtectionVariation = protectionItem.variants.find(({ id }) => id === selectedProtectionVariationId);
    }
    const protectionBlock = document.getElementById('cartUpgrade');
    if (protectionBlock) {
      protectionBlock.style.display = (!chocolates.length || !selectedProtectionVariation.available) ? 'none' : '';
      const isEnabled = localStorage.getItem('protection') === 'true' && selectedProtectionVariation?.available && chocolates.length;
      const toggle = document.getElementById('cartBodyUpgradeInput');
      toggle.checked = isEnabled;
      toggle.addEventListener('change', onProtectionToggle.bind(this));
      if (localStorage.getItem('protection') === 'true' && (!selectedProtectionVariation?.available || !chocolates.length)) {
        localStorage.removeItem('protection');
      }
      this.updateSubtotals(isEnabled);
    } else {
      this.updateSubtotals(false);
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.js-contents',
        childSectionSelectors: [
          '.drawer__heading',
          '.cart__free-shipping',
          '.drawer__contents',
          // '.cart-drawer__footer-info'
        ]
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  closeUpsells(cartDrawerInner) {
    this.cartDrawerUpsells.style.transform = 'translate(100%)';
    this.cartDrawerUpsells.addEventListener('transitionend', () => {
      if (cartDrawerInner) cartDrawerInner.classList.remove('drawer__inner--no-border');
      this.cartDrawerUpsells.classList.add('close');
    }, { once: true });
  }

  updateUpsells(cartRecommendationsHtml, cartDrawerInner) {
    if (cartRecommendationsHtml === "") {
      this.cartDrawerUpsells.classList.remove('cart-drawer-recommendations--loading');
      this.closeUpsells(cartDrawerInner);
    } else {
      const cartDrawerRecommendationsList = this.cartDrawerUpsells.querySelector('.cart-drawer-recommendations__list');
      if (cartDrawerRecommendationsList) {
        cartDrawerRecommendationsList.classList.add('disable-list');
        if (cartDrawerInner) cartDrawerInner.classList.add('drawer__inner--no-border');
        this.cartDrawerUpsells.classList.remove('close');
      }

      setTimeout(() => {
        this.cartDrawerUpsells.innerHTML = cartRecommendationsHtml;
      }, 200);
    }
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

class CartRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        if (this.classList.contains('product-recommendations--loaded')) {
          return;
        }
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('cart-recommendations');
        const cartDrawerUpsells = this.closest('.cart-drawer-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          cartDrawerUpsells.classList.remove('cart-drawer-recommendations--loading');
          this.innerHTML = recommendations.innerHTML;
          const cartDrawerRecommendationsList = this.querySelector('.cart-drawer-recommendations__list');

          if (cartDrawerRecommendationsList) {
            setTimeout(() => {
              this.querySelector('.cart-drawer-recommendations__list').classList.remove('disable-list');
            });
          }
        }

        const cartDrawerInner = cartDrawerUpsells.closest('.drawer__inner');
        if (!this.querySelector('.cart-drawer-recommendations__list')) {
          cartDrawerUpsells.classList.add('close');
          setTimeout(() => {
            if (cartDrawerInner) cartDrawerInner.classList.remove('drawer__inner--no-border');
          }, 200);
        } else {
          if (cartDrawerInner) cartDrawerInner.classList.add('drawer__inner--no-border');
          cartDrawerUpsells.classList.remove('close');
        }

        this.classList.add('product-recommendations--loaded');

        if (this.classList.contains('complementary-products') ) {
          this.querySelectorAll('script').forEach(oldScriptTag => {
            const newScriptTag = document.createElement('script');
            Array.from(oldScriptTag.attributes).forEach(attribute => {
              newScriptTag.setAttribute(attribute.name, attribute.value)
            });
            newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
            oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
          });
        }
      })
      .catch(e => {
        console.error(e);
      });
  }
}

customElements.define('cart-recommendations', CartRecommendations);
